import React, { useEffect, useState } from "react";
import "./styles.scss";
import { JobCard, NewsGroup, TrendingNewsCard } from "../../../components";
import { useHistory, withRouter } from "react-router-dom";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { getNewsByWidget } from "../../news/service/news.service";
import {
  getNewGazette,
  getNewJobs,
} from "../../CreateNewItem/CreateNewGazette/service/jobs.service";
import GazetteViewCard from "../../../components/gazetteViewCard";
import moment from "moment";
import { setJobCategoryList, setJobs } from "../../Jobs/redux/actions";
import { getAllJobsCategory } from "../../CreateNewItem/CreateNewJob/service/jobs.service";

const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [getGazette, setGetGazette] = useState("");
  const [getJobs, setGetJobs] = useState([]);
  const [selectGazette, setSelectGazette] = useState([]);
  const [jobCategory, setJobCategory] = useState([]);

  const { jobCategoryList, jobList } = useSelector(
    ({ jobsReducer }) => jobsReducer
  );

  const history = useHistory();
  const dispatch = useDispatch();

  const fetchNewGazette = async () => {
    try {
      const response = await getNewGazette();
      const res_job = await getNewJobs();
      console.log("get new gazette", response);
      console.log("get new Jobs", res_job);
      if (response?.data?.data) {
        setGetGazette(response?.data?.data);
      } else {
        setGetGazette([]);
      }
      if (res_job?.data) {
        setGetJobs(res_job?.data?.data);
      } else {
        setGetJobs([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNewGazette();
  }, []);

  const fetchCategories = async () => {
    const response = await getAllJobsCategory();
    if (response?.data) {
      setJobCategory(response.data);
      dispatch(setJobCategoryList(response.data));
    }
  };

  const fetchTagName = (id) => {
    const isExist = (jobCategoryList || jobCategory)?.find(
      (x) => x?.job_category_id === id
    );
    console.log({ isExist });
    return isExist?.jobs_category_name;
  };

  useEffect(() => {
    if (jobCategoryList?.length === 0) {
      fetchCategories();
    }
  }, []);

  return (
    <>
      <NewsGroup
        data={{
          titleName: props.title,
          mainType: "noBoarder",
          type: "en",
          linkName: "",
        }}
        is_header={props.title ? true : false}
      >
        {props.is_gazette && (
          <div className="pl-3 pr-3 mt-3">
            {getGazette.length > 0 &&
              [...getGazette]
                .sort(
                  (a, b) =>
                    new Date(b.gazette_date).getTime() -
                    new Date(a.gazette_date).getTime()
                )

                .map((gazette) => (
                  <GazetteViewCard
                    // key={gazette?.gazette_id}
                    isSelect={selectGazette === gazette?.gazette_id}
                    titleEn={
                      "Gazette of the Democratic Socialist Republic of Sri Lanka"
                    }
                    titleSi={
                      "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජයේ ගැසට් පත්‍ර"
                    }
                    gazetteDate={gazette?.gazette_date}
                    created_at={gazette?.created_at}
                    organization={gazette?.tags}
                    views={gazette?.views || 0}
                    isArrow={true}
                    onClickView={() => {
                      setSelectGazette(gazette?.gazette_id);

                      props.history.push(
                        `/government-gazette/${moment(
                          gazette?.gazette_date
                        ).format("YYYY-MM-DD")}/${gazette?.gazette_id}`
                      );
                    }}
                  />
                ))}
          </div>
        )}

        {!props.is_gazette && (
          <div className="pl-3 pr-3 mt-3">
            {Array.isArray(getJobs) && getJobs.length > 0 ? (
              [...getJobs]
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                .map((jobs) => (
                  <JobCard
                    key={jobs?.job_id}
                    data={{
                      imgUrl: jobs?.banner_img?.file_url || jobs?.banner_img,
                      titleEn: jobs?.job_title?.en,
                      titleSi: jobs?.job_title?.si,
                      closingDate: jobs?.closing_date,
                      organization: fetchTagName(jobs?.organization) || "",
                      type: jobs?.job_application_type,
                      views: jobs?.views || 0,
                      downloads: jobs?.downloads || 0,
                      isArrow: true,
                    }}
                    // isOpen={activeCard === jobs?.job_id}
                    onClickView={() => {
                      // setSelectJobs(jobs?.job_id);
                      // setActiveCard(jobs?.job_id);
                      dispatch(setJobs(jobs));
                      // props.history.push("/gov-jobs/gov-job-view");
                      if (jobs?.keywords) {
                        props.history.push(
                          `/jobs/${jobs?.keywords}/${jobs?.job_id}`
                        );
                      } else {
                        const generatedSlug = jobs.job_title?.["si"]
                          ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                          ?.replace(/\s*-\s*/g, " ")
                          ?.replace(/\s*–\s*/g, " ")
                          ?.trim()
                          .split(/\s+/)
                          .slice(0, 5)
                          .join("-")
                          .replace(/-+/g, "-");
                        props.history.push(
                          `/jobs/${generatedSlug}/${jobs?.job_id}`
                        );
                      }
                    }}
                  />
                ))
            ) : (
              <div className="error-message">No Jobs Found</div>
            )}
          </div>
        )}
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
